// AUTO-GENERATED SQL Builder (V40 Final) for BookingSlotSelection
import { 
  SqlField, 
  SqlExp, 
  SqlExpChain, 
  SqlFn, 
  SqlLiteral, 
  SqlSubQuery, 
  SqlApplyColumn, 
  SqlNavHybrid, 
  createNavHybrid 
} from '../utils/sql-core';
import { SqlAst } from '../utils/sql-ast';

export class BookingSlotSelectionSql {
  private ast = new SqlAst('BookingSlotSelection', 'bookingSlotSelection');
  public readonly main: any = {};

  public guid: SqlField;
  public bookingId: SqlField;
  public serviceCategoryId: SqlField;
  public slotOptionId: SqlField;
  public amount: SqlField;
  public booking: SqlNavHybrid;
  public createdByUser: SqlNavHybrid;
  public serviceCategory: SqlNavHybrid;
  public slotOption: SqlNavHybrid;
  public updatedByUser: SqlNavHybrid;
  public id: SqlField;
  public isDeleted: SqlField;
  public createdBy: SqlField;
  public createdDate: SqlField;
  public updatedBy: SqlField;
  public updatedDate: SqlField;

  constructor() {
    this.guid = new SqlField('bookingSlotSelection', 'guid', '', 'id', 'bookingSlotSelection_guid');
    this.bookingId = new SqlField('bookingSlotSelection', 'bookingId', 'booking', 'id', 'bookingSlotSelection_booking');
    this.serviceCategoryId = new SqlField('bookingSlotSelection', 'serviceCategoryId', 'serviceCategory', 'id', 'bookingSlotSelection_serviceCategory');
    this.slotOptionId = new SqlField('bookingSlotSelection', 'slotOptionId', 'slotOption', 'id', 'bookingSlotSelection_slotOption');
    this.amount = new SqlField('bookingSlotSelection', 'amount', '', 'id', 'bookingSlotSelection_amount');
    this.booking = createNavHybrid('bookingSlotSelection', 'bookingSlotSelection_booking', 'Booking');
    this.createdByUser = createNavHybrid('bookingSlotSelection', 'bookingSlotSelection_createdByUser', 'User');
    this.serviceCategory = createNavHybrid('bookingSlotSelection', 'bookingSlotSelection_serviceCategory', 'ServiceCategory');
    this.slotOption = createNavHybrid('bookingSlotSelection', 'bookingSlotSelection_slotOption', 'SlotOption');
    this.updatedByUser = createNavHybrid('bookingSlotSelection', 'bookingSlotSelection_updatedByUser', 'User');
    this.id = new SqlField('bookingSlotSelection', 'id', '', 'id', 'bookingSlotSelection_id');
    this.isDeleted = new SqlField('bookingSlotSelection', 'isDeleted', '', 'id', 'bookingSlotSelection_isDeleted');
    this.createdBy = new SqlField('bookingSlotSelection', 'createdBy', '', 'id', 'bookingSlotSelection_createdBy');
    this.createdDate = new SqlField('bookingSlotSelection', 'createdDate', '', 'id', 'bookingSlotSelection_createdDate');
    this.updatedBy = new SqlField('bookingSlotSelection', 'updatedBy', '', 'id', 'bookingSlotSelection_updatedBy');
    this.updatedDate = new SqlField('bookingSlotSelection', 'updatedDate', '', 'id', 'bookingSlotSelection_updatedDate');

    for (const k of Object.keys(this)) {
      const v = (this as any)[k];
      if (v instanceof SqlField) this.main[k] = v;
    }
  }

  // SELECT
  select(fn:(x:BookingSlotSelectionSql)=>any) {
    this.ast.addSelectObject(fn(this));
    return this;
  }

  // WHERE
  where(fn:(x:BookingSlotSelectionSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  and(fn:(x:BookingSlotSelectionSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  or(fn:(x:BookingSlotSelectionSql)=>SqlExp | SqlExpChain) {
    this.ast.addOr(fn(this));
    return this;
  }

  // JOIN
  join(fn:(x:BookingSlotSelectionSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f);
    return this;
  }
  leftJoin(fn:(x:BookingSlotSelectionSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'LEFT');
    return this;
  }
  rightJoin(fn:(x:BookingSlotSelectionSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'RIGHT');
    return this;
  }

  // AND JOIN
  andJoin(fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    const last = this.ast.joins[this.ast.joins.length - 1];
    if (!last) throw new Error('andJoin() before join()');

    const left = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(this.ast.alias, prop)
    });
    const right = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(last.alias, prop)
    });

    const exp = (this.ast as any).compileExp(fn(left, right));

    if (typeof last.on === 'string') {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[
          { column:last.on, operator:'', value:null, isTrusted:true, subFilters:[] },
          exp
        ]
      };
    }
    else if (last.on.logic === 'And') {
      last.on.subFilters.push(exp);
    }
    else {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[ last.on, exp ]
      };
    }

    return this;
  }

  // CTE
  with(name:string, fn:(c:any)=>any) {
    this.ast.with(name, fn);
    return this;
  }
  withRecursive(name:string, fn:(c:any)=>any) {
    this.ast.withRecursive(name, fn);
    return this;
  }

  // CTE JOIN
  joinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.joinCTE(name, alias, fn);
    return this;
  }
  fullJoinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.fullJoinCTE(name, alias, fn);
    return this;
  }

  // SUBQUERY
  subQuery(fn:(b:any)=>any) {
    return new SqlSubQuery(fn);
  }

  // APPLY
  apply(name:string, fn:(b:any)=>any) {
    this.ast.apply(name, fn);
    return this;
  }
  applyColumn(name:string, fn:(b:any)=>SqlField) {
    return this.ast.applyColumn(name, fn);
  }
  crossApply(app:any) {
    this.ast.crossApply(app);
    return this;
  }

  // GROUP BY
  groupBy(fn:(x:BookingSlotSelectionSql)=>SqlField[]) {
    this.ast.addGroup(fn(this));
    return this;
  }

  // HAVING
  having(fn:(x:BookingSlotSelectionSql)=>SqlExp | SqlExpChain) {
    this.ast.addHaving(fn(this));
    return this;
  }

  // ORDER
  orderBy(fn:(x:BookingSlotSelectionSql)=>any[]) {
    this.ast.addOrder(fn(this));
    return this;
  }

  // UNION
  union(fn:(q:any)=>any) {
    this.ast.union(fn);
    return this;
  }
  unionAll(fn:(q:any)=>any) {
    this.ast.unionAll(fn);
    return this;
  }

  limit(n:number) { this.ast.take = n; return this; }
  offset(n:number) { this.ast.skip = n; return this; }

  build() {
    return this.ast.toQueryDescriptor();
  }
}
